/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RedeemTokenMutationVariables = {|
  token: string
|};
export type RedeemTokenMutationResponse = {|
  +redeemToken: ?{|
    +token: string
  |}
|};
export type RedeemTokenMutation = {|
  variables: RedeemTokenMutationVariables,
  response: RedeemTokenMutationResponse,
|};
*/


/*
mutation RedeemTokenMutation(
  $token: String!
) {
  redeemToken(token: $token) {
    token
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token",
    "type": "String!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "token",
        "variableName": "token"
      }
    ],
    "concreteType": "RedeemTokenMutation",
    "kind": "LinkedField",
    "name": "redeemToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RedeemTokenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RedeemTokenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "RedeemTokenMutation",
    "operationKind": "mutation",
    "text": "mutation RedeemTokenMutation(\n  $token: String!\n) {\n  redeemToken(token: $token) {\n    token\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '882fa032142a3468b81f8a026bc26fff';

module.exports = node;
